<div style="width: 500px; height: 500px;">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;">
      <div class="section-header-title" data-cy="organizer-case-tooth-title">
        Change Case / Tooth
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; overflow-y: hidden;">
      <div style="display: flex; flex-direction: column; height: 100%;">
        <div style="flex: 1; display: flex; flex-direction: column; height: 100%; max-height: 100%; overflow-y: hidden;">
          <div style="flex-basis: fit-content; font-weight: 500; color: var(--tdo-primary-accent);" data-cy="organizer-cases-label">Cases:</div>
          <div style="display: flex; font-weight: 500; font-size: 14px;" data-cy="organizer-case-header">
            <div style="flex: 1;" data-cy="organizer-case-description-header">Description</div>
            <div style="flex: 1;" data-cy="organizer-case-teeth-header">Teeth</div>
            <div style="flex: 1;" data-cy="organizer-case-date-header">Date</div>
          </div>
          <div style="flex: 1; overflow-y: auto; display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="organizer-cases-container">
            <div (click)="onCaseClick(cse)" [ngClass]="{'case-tooth-dialog-item-selected': selectedCase === cse}" class="case-tooth-dialog-item" *ngFor="let cse of cases" data-cy="organizer-case-item">
              <div style="display: flex;">
                <div style="flex: 1;" data-cy="organizer-case-description">{{cse.Description}}</div>
                <div style="flex: 1;" data-cy="organizer-case-teeth">{{cse.Teeth}}</div>
                <div style="flex: 1;" data-cy="organizer-case-date">{{cse.DateString}}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="flex-basis: 80px; min-height: 80px; display: flex; flex-direction: column;">
          <div style="flex-basis: fit-content; font-weight: 500; color: var(--tdo-primary-accent);" data-cy="organizer-teeth-label">Teeth:</div>
          <div style="flex: 1; overflow-y: auto; display: flex; flex-wrap: wrap; height: 100%; max-height: 100%; margin-top: 6px;" data-cy="organizer-teeth-container">
            <div *ngFor="let tooth of selectedCase?.DataTeethIdsList">
              <div *ngIf="tooth.Notation">
              <mat-checkbox #cb [checked]="isChecked(tooth)" (change)="onCheckboxChange($event, tooth, cb)" labelPosition="before" style="margin-right: 20px;" data-cy="organizer-tooth-checkbox">{{tooth.Notation}}</mat-checkbox>
              </div>
            </div>
            <div *ngIf="selectedCase?.TeethList.length === 0" style="width: 100%; text-align: center;" data-cy="organizer-no-teeth-message">
              No teeth assigned to case.  You must assign teeth to this case first.
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="organizer-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="organizer-ok-button">Ok</button>
    </div>
  </div>
</div>
